import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aditya-rnd',
  templateUrl: './rnd.component.html',
  styleUrls: ['./rnd.component.css']
})
export class RndComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
